var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAudioSpeedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.3486 8.66895C17.3486 13.4062 13.4062 17.3379 8.66895 17.3379C3.94238 17.3379 0 13.4062 0 8.66895C0 3.93164 3.93164 0 8.6582 0C13.3955 0 17.3486 3.93164 17.3486 8.66895ZM4.57617 5.0918L7.80957 9.75391C8.42188 10.6455 9.45312 10.7959 10.1943 10.0762C10.9141 9.31348 10.7744 8.28223 9.89355 7.68066L5.2207 4.43652C4.75879 4.11426 4.25391 4.61914 4.57617 5.0918Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioSpeedIcon);
export default __webpack_public_path__ + "static/media/audio_speed_icon.296b18222c998e2d65dbeb620803d742.svg";
export { ForwardRef as ReactComponent };